import { getTimezoneAbbreviation } from './timezoneUtils';

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function formatScheduleSummary(schedules) {
  if (!schedules?.length) return '—';
  return schedules
    .map((s) => {
      const start = String(s.start_time).slice(0, 5);
      const end = String(s.end_time).slice(0, 5);
      return `${dayNames[s.day_of_week] || s.day_of_week} ${start}–${end}`;
    })
    .join('; ');
}

export function formatTimezoneDetails(country, timezone) {
  if (!country && !timezone) return '—';
  const abbr = timezone ? getTimezoneAbbreviation(timezone) : '';
  const parts = [];
  if (country) parts.push(country);
  if (timezone) {
    parts.push(timezone === abbr ? timezone : `${timezone}${abbr ? ` (${abbr})` : ''}`);
  }
  return parts.join(' · ');
}

/** Failures first, then alphabetical by batch name. */
export function sortBulkShiftResults(batches) {
  return [...(batches || [])].sort((a, b) => {
    if (a.ok !== b.ok) return a.ok ? 1 : -1;
    const nameA = (a.batchName || a.batchId || '').toLowerCase();
    const nameB = (b.batchName || b.batchId || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
}
